module.exports = __webpack_public_path__ + "static/media/ES.90894cc9.png";